import { AsyncPipe, DatePipe, NgIf, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import vi from '@angular/common/locales/vi';
import { NgModule } from '@angular/core';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoadingSpinnerModule } from '@shared/components/loading-spinner/loading-spinner.module';
import { vi as viN } from 'date-fns/locale';
import { NZ_DATE_LOCALE } from 'ng-zorro-antd/i18n';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SecretInterceptor } from './core/interceptor/secret.interceptor';
import { AGENCY_CONFIG_STATE_NAME } from './features/agency-config/states/agencyConfig';
import { AgencyConfigEffects } from './features/agency-config/states/agencyConfig.effects';
import { agencyConfigReducer } from './features/agency-config/states/agencyConfig.reducer';
import { CoinConfigComponent } from './features/coin-config/coin-config.component';
import { CommissionReportComponent } from './features/commission-report/commission-report.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { NewsFeedComponent } from './features/news-feed/news-feed.component';
import { testReducer } from './features/test/state/test.reducer';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

registerLocaleData(vi);
@NgModule({
  declarations: [
    AppComponent,
    CoinConfigComponent,
    DashboardComponent,
    CommissionReportComponent,
    NewsFeedComponent,
  ],
  imports: [
    AppRoutingModule,
    CoreModule.forRoot(),
    LoadingSpinnerModule,
    ImageCropperModule,
    AsyncPipe,
    NgIf,
    StoreModule.forFeature(AGENCY_CONFIG_STATE_NAME, agencyConfigReducer),
    StoreModule.forFeature('test', testReducer),
    EffectsModule.forFeature(AgencyConfigEffects),
    NzNotificationModule,
    BrowserAnimationsModule,
    MatAutocompleteModule
  ],
  bootstrap: [AppComponent],
  providers: [
    DatePipe,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    // { provide: HTTP_INTERCEPTORS, useClass: SecretInterceptor, multi: true },
    provideHttpClient(withInterceptors([SecretInterceptor])),
    { provide: NZ_DATE_LOCALE, useValue: viN },
  ],
})
export class AppModule {}
